export default __webpack_public_path__ + "static/media/complementary--when-wet--g1.11ed4478.png";